export enum CheckoutFooterLinkMessageId {
    TermsAndConditions = 'termsAndConditions',
    Privacy = 'privacy',
    TermsOfUse = 'termsOfUse',
    OnlineMarketplace = 'onlineMarketplace',
    LegalNotice = 'legalNotice',
    CookieSettings = 'cookieSettings',
    Compliance = 'compliance',
    Accessibility = 'accessibility',
}
